import {
  List,
  ListItemText,
  ListItemButton,
  Collapse,
  Box,
} from "@mui/material";
import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router";

import {
  politicalGuidePages,
  membershipGuidePages,
} from "@/components/UserGuide/userGuidePages";
import { useUpdateDataContext } from "@/contexts/UpdateDataContext";

function UserGuideSideMenu() {
  const location = useLocation();
  const navigate = useNavigate();
  const [updateDataOpen, setUpdateDataOpen] = useState(false);
  const [apiDocsOpen, setApiDocsOpen] = useState(false);
  const [pages, setPages] = useState(null);
  const { workflow } = useUpdateDataContext();

  useEffect(() => {
    if (workflow === "membership") {
      setPages(membershipGuidePages);
    } else {
      setPages(politicalGuidePages);
    }
  }, [workflow]);

  const handleClick = (page) => {
    if (page.url) {
      navigate(page.url);
    } else {
      if (page.title === "Update Data Guide") {
        setUpdateDataOpen(!updateDataOpen);
      } else {
        setApiDocsOpen(!apiDocsOpen);
      }
    }
  };

  const getCollapseState = (pageTitle) => {
    if (pageTitle === "Update Data Guide") {
      return updateDataOpen;
    } else if (pageTitle === "API Documentation") {
      return apiDocsOpen;
    }
    return false;
  };

  return (
    <List id="user-guide-side-menu">
      {pages &&
        pages.map((page) => {
          return (
            <Box key={page.title}>
              <ListItemButton
                sx={{ padding: "15px 35px" }}
                onClick={() => handleClick(page)}
                className={
                  location.pathname.includes(page.url)
                    ? "active-user-guide-cat"
                    : ""
                }
              >
                <ListItemText>{page.title}</ListItemText>
              </ListItemButton>
              {page.subPages && (
                <Collapse
                  in={getCollapseState(page.title)}
                  timeout="auto"
                  unmountOnExit
                >
                  <List component="div" disablePadding>
                    {page.subPages.map((page) => (
                      <ListItemButton
                        key={page.url}
                        sx={{ paddingLeft: "50px" }}
                        onClick={() => handleClick(page)}
                        className={
                          location.pathname.includes(page.url)
                            ? "active-user-guide-cat"
                            : ""
                        }
                      >
                        <ListItemText primary={page.title} />
                      </ListItemButton>
                    ))}
                  </List>
                </Collapse>
              )}
            </Box>
          );
        })}
    </List>
  );
}

export default UserGuideSideMenu;
